// Inspired by https://www.w3.org/TR/wai-aria-practices/examples/accordion/accordion.html

import { mapMutations, mapGetters } from 'vuex'
import classNameMixin from 'mixins/className'
import uniqueId from 'lodash.uniqueid'
import RichText from 'components/RichText'
import verifyLeadingSlashLang from 'util/verifyLeadingSlashLang'

import './style.scss'

export default {
  name: 'AccordionSection',
  props: {
    section: {
      type: Object,
      default: null
    },
    isNavigation: {
      type: Boolean,
      default: false
    },
    modifiers: {
      type: Array,
      default: () => []
    }
  },
  mixins: [classNameMixin],
  data: () => ({
    uuid: '',
    isExpanded: false
  }),
  computed: {
    ...mapGetters(['lang'])
  },
  beforeMount () {
    this.uuid = uniqueId()
  },
  methods: {
    handleClick () {
      this.isExpanded = !this.isExpanded
    },
    ...mapMutations({
      closeMenu: 'CLOSE_MENU'
    })
  },
  render (h) {
    const { section, uuid, isExpanded, isNavigation, modifiers, handleClick, closeMenu, lang } = this

    const stateClasses = {
      isHidden: (isExpanded ? '' : ' is-hidden'),
      isExpanded: (isExpanded ? ' is-expanded' : '')
    }

    const headerDefault = <dt class='AccordionSection__header'
      role='heading'
      aria-level='3'
    >
      <button class='AccordionSection__trigger'
        aria-expanded={isExpanded}
        aria-controls={`accordion-section-${uuid}`}
        id={`accordion-id-${uuid}`}
        onClick={handleClick.bind(this)}
      >
        <span class='AccordionSection__title' domPropsInnerHTML={section.title} />
        <span class='Accordion-icon'></span>
      </button>
    </dt>

    const headerNavigation = <dt class='AccordionSection__header'
      role='heading'
      aria-level='3'
    >
      <div onClick={closeMenu}>
        <router-link class='AccordionSection__header-link' to={section.object_slug ? verifyLeadingSlashLang(section.object_slug, lang) : verifyLeadingSlashLang('404', lang) }>
          <span class='AccordionSection__title'
            domPropsInnerHTML={section.title}
          />
        </router-link>
      </div>
      <button class='AccordionSection__trigger'
        aria-expanded={isExpanded}
        aria-controls={`accordion-section-${uuid}`}
        id={`accordion-id-${uuid}`}
        onClick={handleClick.bind(this)}
      >
      </button>
    </dt>

    const contentDefault = <dd class={`AccordionSection__content${stateClasses.isHidden}`}
      id={`accordion-section-${uuid}`}
      role='region'
      aria-labelledby={`accordion-id-${uuid}`}
      hidden={stateClasses.isHidden ? 'hidden' : null}
    >
      <RichText class='AccordionSection__content-inner'
        content={section.content}
      />
    </dd>

    const contentNavigation = <dd class={`AccordionSection__content${stateClasses.isHidden}`}
      id={`accordion-section-${uuid}`}
      role='region'
      aria-labelledby={`accordion-id-${uuid}`}
      hidden={stateClasses.isHidden ? 'hidden' : null}
    >
      {section.children && section.children.length
        ? (<ul class='AccordionSection__list'>
        {section.children.map(c => (
          <li class='AccordionSection__list-item'
            onClick={closeMenu}
          >
            { /* TODO: Get full path from children, maybe it's better not to assume they're directly nested */ }
            <router-link to={verifyLeadingSlashLang(`${section.object_slug}/${c.object_slug}`, lang)} class={'AccordionSection__list-item-link'}>
              {c.title}
            </router-link>
          </li>
      ))}
      </ul>)
      : null}
    </dd>

    return (
      section
      ? <div class={`${this.className(this.$options.name, modifiers)}${stateClasses.isExpanded}`}>
        {isNavigation ? headerNavigation : headerDefault}
        {isNavigation ? contentNavigation : contentDefault}
      </div>
      : null
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/AccordionSection/index.js